import * as Service from 'types/service';
import { SharedAppConstants } from '@tock/shared-app-constants';
import { dashboard } from 'types';
import protos from 'utils/protos';

const { TextingSendRequest, WalkInPartyDescription } = protos;

export function sendTextMessage(
  to: string,
  label: string,
  message: string,
  partyId: number,
  serviceDate: string,
  messageType: dashboard.TextMessage.MessageType
): ApiAction {
  const request = TextingSendRequest.fromObject({
    label,
    message,
    partyId,
    serviceDate,
    to,
    messageType,
  });

  return {
    TockApi: {
      postProto: '/texting/send',
      request,
      type: SharedAppConstants.NULL,
      toast: 'Message sent',
    },
  };
}

export function sendWalkinConfirmation(
  walkInPartyDescription: Service.ElmWalkInPartyDescription
): ApiAction {
  return {
    TockApi: {
      postProto: '/walkin-waitlist/text-confirmation',
      request: WalkInPartyDescription.fromObject(walkInPartyDescription),
      type: SharedAppConstants.NULL,
      toast: 'Confirmation message sent',
    },
  };
}
